/* Preisdarstellung: Währungszeichen in ein eigenes <span> fassen, damit es
 * kleiner gesetzt werden kann ("296,63 €" -> "296,63" + kleines "€").
 *
 * Warum ein MutationObserver: assets/template-product.js ersetzt beim
 * Variantenwechsel den kompletten innerHTML von #price-<section>. Das frisch
 * eingesetzte Markup muss erneut umgebaut werden.
 *
 * Faellt sicher aus: passt das Muster nicht (Waehrung vorangestellt, kein
 * Trennzeichen, verschachteltes Markup), bleibt der Preis unveraendert.
 */
(function () {
  if (customElements.get('kb-price')) return;

  // Nur der Verkaufspreis, nicht der Streichpreis.
  var TARGETS = '.price__regular .price-item--regular, .price__sale .price-item--sale';

  class KbPrice extends HTMLElement {
    connectedCallback() {
      if (this.dataset.splitCurrency !== 'true') return;
      this.process();
      this.observer = new MutationObserver(this.process);
      this.observer.observe(this, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    process = () => {
      if (this.busy) return;
      this.busy = true;
      if (this.observer) this.observer.disconnect();

      try {
        this.querySelectorAll(TARGETS).forEach(function (el) {
          // Verschachteltes Markup (z. B. "Ab …"-Auszeichnung) nicht anfassen.
          if (el.children.length || el.dataset.kbpDone) return;

          var text = el.textContent.trim();
          var cut = text.lastIndexOf(' ');
          if (cut <= 0) return;

          var amount = text.slice(0, cut);
          var currency = text.slice(cut + 1);
          // Alles mit Ziffer dahinter ist kein Währungszeichen.
          if (!currency || /\d/.test(currency)) return;

          el.textContent = amount;
          var span = document.createElement('span');
          span.className = 'kb-price__cur';
          span.textContent = currency;
          el.appendChild(span);
          el.dataset.kbpDone = '1';
        });
      } finally {
        this.busy = false;
        if (this.observer && this.isConnected) {
          this.observer.observe(this, { childList: true, subtree: true });
        }
      }
    };
  }

  customElements.define('kb-price', KbPrice);
})();
